import { createFileRoute } from "@tanstack/react-router";

import LocaleSettings from "@/user/components/settings/LocaleSettings";

export const Route = createFileRoute("/_panel/_settings/settings/locale")({
  component: RouteComponent,
});

function RouteComponent() {
  return <LocaleSettings />;
}
